<template>
  <div class="flexbox mr-b-10 gap-10">
    <div class="w-200">
      <router-link :to="{ name: 'VideoList'}">
        <img class="img-responsive" src="https://image-yoshino.sakura.ne.jp/monster/SaleMonTv.png" loading="lazy">
      </router-link>
    </div>
    <div class="search-bar">
      <input type="text" v-model="searchQuery" class="search-input" @keyup.enter="handleSearch()" placeholder="検索" />
      <select class="form-control" v-model="category" @change="handleSearch()">
        <option value="">全てのカテゴリ</option>
        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
      </select>
      <button class="search-button" @click="handleSearch()">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      searchQuery: '',
      category: ''
    }
  },
  computed: {
    categories () {
      return this.$store.getters.getCategories
    }
  },
  mounted () {
    this.searchQuery = this.$route.query.search_query || ''
    this.category = this.$route.query.category || ''
  },
  methods: {
    handleSearch () {
      const query = { ...this.$route.query }
      if (this.searchQuery) {
        query['search_query'] = this.searchQuery
      } else {
        delete query['search_query']
      }

      if (this.category) {
        query['category'] = this.category
      } else {
        delete query['category']
      }

      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        const logParams = {
          name: eventCode.video.search,
          properties: {
            searchQuery: this.searchQuery,
            category: this.category
          }
        }
        EventService.postTrackLog(logParams)

        this.$router.push({
          name: 'VideoList',
          query: query
        })
      }
    }
  }
}
</script>
<style scoped>
.search-bar {
  display: flex;
  justify-content: center;
  width: 70%;
  height: 40px;

  .search-input {
    width: 60%;
    padding: 5px 15px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 24px 0 0 24px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #3ea6ff;
    }
  }

  .form-control {
    width: unset;
    border-radius: unset;
    color: #666;
    border: 1px solid #ccc !important;
    border-left: none !important;
    height: 100%;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #f8f8f8;
    &:focus {
      border-color: #3ea6ff;
    }
    &:hover {
      background-color: #e8e8e8;
    }
  }

  .search-button {
    padding: 5px 15px;
    background-color: #f8f8f8;
    border: 1px solid #ccc;
    border-left: none;
    border-radius: 0 24px 24px 0;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.2s;
    color: #666;

    &:hover {
      background-color: #3ea6ff;
      border-color: #3ea6ff;
      color: #fff;
    }
  }
}
@media (max-width: 425px) {
  .search-bar {
    width: 100%;
  }
  .form-control {
    max-width: 140px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/Search.vue